import { lazy } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

const
  QuienesSomos = lazy(() => import('../../../views/QuienesSomos/index'))


const Index = (props: any) => {
  return (
    <Switch>
      <Route path={`${props.match.path}`} component={QuienesSomos} />
      <Redirect to='/error/404' />
    </Switch>
  )
}

export default Index
